import React, { PropTypes } from "react";
import { FormattedHTMLMessage, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { SelectInput } from "../../../common/form";
import { ACTIVE, INACTIVE, PLANNED_INACTIVE } from "../enums/clientStatusTypes";
import { RECURRING } from "../enums/billingPeriodTypes";
import validClientStatusTransitions from "../enums/validClientStatusTransitions";

import moment from "moment";
import { toast } from "react-toastify";
import * as dataActions from "../../../../utils/data/dataActions";
import { BSModal } from "../../../common";
import AutoSave from "../../../common/AutoSave/AutoSave";
import PlannedInactiveForm from "./change-status/PlannedInactiveForm";
import { CLIENT_CHANGE_STATUS, CLIENT_V2 } from "../../../../utils/data/models";
import userHasAccess from "../../../../utils/userHasAccess";
import { ADMINISTRATOR, FINTECH } from "../../../../utils/Roles";
import { EN, FR } from "../../../common/enums/languages";
import {
    getParsedErrors,
    renderConfirmationModal,
    renderErrorModal,
} from "../../../common/form/FieldErrorHelper";
import { isClientInTransition } from "../../../common/RouteValidators/ClientValidationHelper";

import * as invoiceActions from "./invoices/invoiceActions";

const formName = "changeStatusDropDown";

class ChangeStatusDropDown extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            changeStatusEndpoint: null,
            changeStatusBody: {},
            statusAPIResponse: null,
            allowAutoSave: false,
            showModalWarning: false,
            warningClosed: false,
            showModalError: false,
            showClientCoverageModal: false,
            confirmedCoverageModal: null,
            validClientStatusTransitions: [],
            errorString: "",
            errorMsgKey: "validation.clientFieldValidation.clientChangeStatusValidationError",
            errorPath: "validation/clientFieldValidation/serverErrors",
            formattedMessageCoverageInfo: {},
            showRetroactiveModal: false,
            showCoverageModificationInfoModal: false,
            className: "",
            disableInactiveButton: false
        };
        this.setAPIResponse = this.setAPIResponse.bind(this);
        this.setAllowAutoSave = this.setAllowAutoSave.bind(this);
        this.getWarningModal = this.getWarningModal.bind(this);
        this.hideWarningModal = this.hideWarningModal.bind(this);
        this.hideErrorModal = this.hideErrorModal.bind(this);
        this.handleServerError = this.handleServerError.bind(this);
        this.clientCoverageModalConfirm = this.clientCoverageModalConfirm.bind(this);
        this.clientCoverageModalOnClose = this.clientCoverageModalOnClose.bind(this);
        this.isFutureCoveragePeriod = this.isFutureCoveragePeriod.bind(this);
        this.renderActivePassageModal = this.renderActivePassageModal.bind(this);
        this.getClientStatusTypeForCurrentStatus = this.getClientStatusTypeForCurrentStatus.bind(this);
        this.setClassName = this.setClassName.bind(this);
        this.manageStatusUpdate = this.manageStatusUpdate.bind(this);
        this.renderPlannedInactiveModal = this.renderPlannedInactiveModal.bind(this);
        this.handlePlanInactive = this.handlePlanInactive.bind(this);
        this.getMinimumLastActiveDate = this.getMinimumLastActiveDate.bind(this);
        this.handlePlannedInactiveSubmit = this.handlePlannedInactiveSubmit.bind(this);
        this.cancelPlanInactive = this.cancelPlanInactive.bind(this);
        this.openErrorModal = this.openErrorModal.bind(this);
    }


    componentDidMount() {
        const clientStatusType = this.props.client.clientStatusType;
        this.setState({
            currentClientStatus: clientStatusType,
        });
        this.setClassName(clientStatusType);
        this.getClientStatusTypeForCurrentStatus(clientStatusType);
    }

    componentDidUpdate(prevProps, prevState) { /** DO NOT remove prevProps argument even if it is not used. 
                                                If not we are not able to access prevState*/
        if (!prevState.confirmedCoverageModal && this.state.confirmedCoverageModal) {
            this.setAllowAutoSave(true, this.props.client.clientId, this.state.statusToBeChanged);
        }
        isClientInTransition(this.props.client.clientId).then((res) => {
            /** Response is either true or false. */
            this.props.updateTransition(res);
        });
        if (this.state.currentClientStatus != this.props.client.clientStatusType) {
            /** If we navigate to another client, and this component is not completely re rendered, we need to update the status. 
            */
            this.manageStatusUpdate(this.props.client.clientStatusType, true);
        }
    }

    openErrorModal(isError, apiRes) {
        const firstColonIndex = isError.data.message.indexOf(':');
        const serverMessage = isError.data.message.substring(firstColonIndex + 1, isError.data.message.length).trim();
        const extraData = isError.data.extraData ? isError.data.extraData : [];
        const userLanguage = localStorage.getItem("languageCode") || "en-CA";

        this.handleServerError(serverMessage, userLanguage, apiRes, extraData);
    }


    handlePlannedInactiveSubmit() {
        const validationErrors = this.refs.form.getWrappedInstance().submit();
        if (validationErrors && Object.keys(validationErrors).length) {
            return validationErrors;
        }
    }

    handlePlanInactive(values) {
        const { clientId } = this.props;

        values.lastActiveDate = values.lastActiveDate.toISOString().split("T")[0];

        const jsonObj = { newStatus: PLANNED_INACTIVE.value, ...values };

        const model = { ...CLIENT_CHANGE_STATUS, path: CLIENT_CHANGE_STATUS.path.replace("{}", clientId) };

        this.props.dataActions
            .simplePost({ model, data: jsonObj })
            .then((data) => {
                if (data.payload.error) {
                    if (data.payload.error.data.error == "client_transition_error") {
                        toast(<FormattedMessage id="validation.clientFieldValidation.clientTransitionError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                    else if (data.payload.error.data.error == "missing_fields_error") {
                        try {
                            this.openErrorModal(data.payload.error, this.state.statusAPIResponse);
                        } catch (error) {
                            /**
                             * Catching unknown API errors.
                             */
                            toast(<FormattedMessage id="validation.clientFieldValidation.unknownAPIError" />, {
                                type: toast.TYPE.ERROR,
                                autoClose: false,
                            });
                        }
                    }
                    else {
                        toast(<FormattedMessage id="genericSaveError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                }
                else {
                    toast(
                        <FormattedMessage
                            id="clients.form.client.planInactiveSuccess"
                        />,
                        {
                            type: toast.TYPE.SUCCESS,
                            autoClose: 5000,
                        }
                    );
                }
                this.props.dataActions.getDataItem(CLIENT_V2, clientId);
                this.props.setShowPlannedInactiveModal(false);
            })
            .catch(() => {
                toast(<FormattedMessage id="genericSaveError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            });
    }

    cancelPlanInactive() {
        this.setState({
            disableInactiveButton: true
        });
        const toastId = toast(<FormattedMessage id="clients.form.client.planInactiveCancelProcess" />, {
            type: toast.TYPE.WARNING,
            autoClose: false,
        });
        const { clientId } = this.props;
        const model = { ...CLIENT_CHANGE_STATUS, path: CLIENT_CHANGE_STATUS.path.replace("{}", clientId) };

        const jsonObj = { newStatus: ACTIVE.value };
        return this.props.dataActions
            .simplePost({ model, data: jsonObj })
            .then((data) => {
                toast.dismiss(toastId.current);
                this.setState({
                    disableInactiveButton: false
                });
                if (data.payload.error) {
                    if (data.payload.error.data.error == "client_transition_error") {
                        toast(<FormattedMessage id="validation.clientFieldValidation.clientTransitionError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                    else {
                        toast(<FormattedMessage id="genericSaveError" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                    }
                }
                else {
                    toast(
                        <FormattedMessage
                            id="clients.form.client.planInactiveCancelSuccess"
                        />,
                        {
                            type: toast.TYPE.SUCCESS,
                            autoClose: 5000,
                        }
                    );
                }
                this.props.dataActions.getDataItem(CLIENT_V2, clientId);
                this.props.setShowPlannedInactiveModal(false);
            })
            .catch(() => {
                this.setState({
                    disableInactiveButton: false
                });
                toast(<FormattedMessage id="genericSaveError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            });
    }

    getMinimumLastActiveDate() {
        const { currentCoveragePeriod, clientHistory } = this.props;
        let coveragePeriodStartDate = null;

        if(currentCoveragePeriod && currentCoveragePeriod.startDate) {
            coveragePeriodStartDate = new Date(currentCoveragePeriod.startDate);

            Object.keys(clientHistory).map((key) => {
            const relationships = clientHistory[key]["relationships"];
            if (relationships) {
                if (relationships.hasOwnProperty("coveragePeriod")) {
                    const startDate = new Date(relationships["coveragePeriod"]["startDate"]);
                    if (startDate < coveragePeriodStartDate) {
                        coveragePeriodStartDate = startDate;
                    }
                }
            }
        });
        }

        return coveragePeriodStartDate;
    }

    handleServerError(serverMessage, userLanguage, apiRes, extraData = undefined) {
        let errorCodesToString = getParsedErrors(
            serverMessage,
            userLanguage,
            this.state.errorPath,
            extraData
        );
        this.setState({
            ...this.state,
            statusAPIResponse: apiRes,
            allowAutoSave: false,
            showModalError: true,
            errorString: errorCodesToString,
        });
    }

    isFutureCoveragePeriod(displayModal = true) {
        /*We change the zone to US to get the accurate comparison for dates regardless of the location */
        if (this.props.client && this.props.client.isBillable) {
            let todaysDate = new Date(
                new Date().toLocaleString("en-US", {
                    timeZone: "UTC",
                })
            );
            todaysDate = todaysDate.toISOString().split("T")[0];
            const coverageStartDate =
                this.props.client.coveragePeriod &&
                this.props.client.coveragePeriod["startDate"].toLocaleString("en-US", {
                    timeZone: "UTC",
                });
            const locale = localStorage.languageCode === EN.value ? localStorage.languageCode : FR.value;
            moment.locale(locale.split("-")[0]);
            if (coverageStartDate && moment(coverageStartDate).isAfter(todaysDate)) {
                const coverageStartMonth = coverageStartDate.split("-")[1];
                const currentMonthName = moment().format("MMMM");
                const coverageMonthName = moment(coverageStartMonth, "MM").format("MMMM");
                this.setState({
                    ...this.state,
                    showClientCoverageModal: displayModal,
                    confirmedCoverageModal: false,
                    formattedMessageCoverageInfo: {
                        nextBP: currentMonthName,
                        coverageMonth: coverageMonthName,
                    },
                });
                return true;
            }
        }
    }

    renderPlannedInactiveModal() {
        const { inactivationReasonType, lastActiveDate, inactivationReasonComplement, showPlannedInactiveModal, disabled } = this.props;
        const minDate = this.getMinimumLastActiveDate();

        const actions = !lastActiveDate
            ? [
                {
                    id: 1,
                    text: <FormattedMessage id="common.confirm" />,
                    action: this.handlePlannedInactiveSubmit,
                },
            ]
            : [];
        return (
            <BSModal
                backdrop={false}
                show={showPlannedInactiveModal}
                closeButtonKey="common.close"
                actions={actions}
                onClose={() => this.props.setShowPlannedInactiveModal(false)}
                title={
                    <span>
                        <FormattedMessage id="clients.form.client.inactivePassageModalTitle" />
                    </span>
                }
                className="plan-inactive-modal"
            >
                <PlannedInactiveForm
                    initialValues={{ lastActiveDate, inactivationReasonType, inactivationReasonComplement }}
                    onSubmit={this.handlePlanInactive}
                    cancelPlanInactive={this.cancelPlanInactive}
                    disableInactiveButton={this.state.disableInactiveButton}
                    minDate={minDate}
                    viewOnly={disabled}
                    ref="form"
                />
            </BSModal>
        );
    }

    renderActivePassageModal() {
        const { statusAPIResponse, showRetroactiveModal, showCoverageModificationInfoModal } = this.state;
        const userLang = localStorage.getItem("languageCode") || EN.value;
        const todaysDate = new Date();
        const nextBP = new Date(todaysDate.getFullYear(), todaysDate.getMonth() + 1);

        const coveragePeriodDate = this.props.client && this.props.client.coveragePeriod
            && this.props.client.coveragePeriod.hasOwnProperty("startDate") ? this.props.client.coveragePeriod["startDate"] : null;

        if (statusAPIResponse && statusAPIResponse.payload.data) {
            if (statusAPIResponse.payload.data.retroactiveBillingPeriods) {
                let bps = "";
                statusAPIResponse.payload.data.retroactiveBillingPeriods.forEach((bp) => {
                    bps += bp["localizations"][userLang]["name"] + "\n\n";
                });
                return (
                    <BSModal
                        backdrop={false}
                        show={showRetroactiveModal}
                        closeButtonKey="common.continue"
                        onClose={() => this.setState({ showRetroactiveModal: false })}
                        title={
                            <span>
                                <FormattedMessage id="validation.clientFieldValidation.attention">
                                    {(f) => <span className="icon warning">{f}</span>}
                                </FormattedMessage>
                            </span>
                        }
                    >
                        <FormattedHTMLMessage
                            id="clients.activationInfo"
                            values={{
                                bp: this.context.intl.formatDate(nextBP, {
                                    year: "numeric",
                                    month: "long",
                                }),
                                client: this.props.client.name,
                            }}
                        />
                        <span className="line-break-display blue">{bps}</span>
                        <br />
                        {this.props.client.clientBillingPeriodType === RECURRING.value && (
                            <div>
                                <FormattedMessage values={{ coverageDate: coveragePeriodDate }} id="validation.clientFieldValidation.clientActivePassageMessage" />
                            </div>
                        )}
                    </BSModal>
                );
            }
            else {
                if (this.props.client.clientBillingPeriodType === RECURRING.value) {
                    return (
                        <BSModal
                            backdrop={false}
                            show={showCoverageModificationInfoModal}
                            closeButtonKey="common.continue"
                            onClose={() => this.setState({ showCoverageModificationInfoModal: false })}
                            title={
                                <span>
                                    <FormattedMessage id="validation.clientFieldValidation.attention">
                                        {(f) => <span className="icon warning">{f}</span>}
                                    </FormattedMessage>
                                </span>
                            }
                        >
                            <FormattedMessage values={{ coverageDate: coveragePeriodDate }} id="validation.clientFieldValidation.clientActivePassageMessage" />
                        </BSModal>
                    );
                }
            }
        }

        return <i className="hidden" />;
    }

    setAPIResponse(apiRes) {
        const isError = apiRes.payload.error;
        const changeStatusBody = this.state.changeStatusBody;
        const { clientId } = this.props;
        if (!isError) {
            /**
             * If API doesn't return an error, we need to check if it was simulation or not (in case of future coverage period).
             * It is is not and client status was successfully activated,
             * we remove the IMPLEMENTATION option from the dropdown, by setting current status to ACTIVE in the parent component.
             * (Will also deactivate client number field).
             */

            this.props.dataActions.getDataItem(CLIENT_V2, clientId).then(() => {
                if (changeStatusBody && changeStatusBody["isSimulation"]) {
                    this.isFutureCoveragePeriod();
                    this.setState({
                        allowAutoSave: false,
                    });
                    return;
                }

                this.setState({
                    ...this.state,
                    statusAPIResponse: apiRes,
                    allowAutoSave: false,
                });
                this.props.updateCurrentStatus(this.state.statusToBeChanged);
                this.manageStatusUpdate(this.state.statusToBeChanged);
                if (
                    apiRes.payload.data.retroactiveBillingPeriods &&
                    apiRes.payload.data.retroactiveBillingPeriods.length > 0
                ) {
                    /**
                     * Logic to display success modal
                     */
                    this.setState({ showRetroactiveModal: true });
                } else {
                    this.setState({ showCoverageModificationInfoModal: true });
                    toast(
                        <FormattedMessage
                            id="validation.clientFieldValidation.activeSuccess"
                            values={{ client: this.props.client.name }}
                        />,
                        {
                            type: toast.TYPE.SUCCESS,
                            autoClose: 5000,
                        }
                    );
                }

                this.props.invoiceActions.setInvoicesRefresh(true);
            });
        } else {
            if (isError.data.error == "client_transition_error") {
                toast(<FormattedMessage id="validation.clientFieldValidation.clientTransitionError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            }
            else {
                try {
                    this.openErrorModal(isError, apiRes);
                } catch (error) {
                    /**
                     * Catching unknown API errors.
                     */
                    toast(<FormattedMessage id="validation.clientFieldValidation.unknownAPIError" />, {
                        type: toast.TYPE.ERROR,
                        autoClose: false,
                    });
                }
            }
        }

    }
    setClassName(clientStatusType) {
        this.setState({
            className: `client-status-type-selected status-indicator status-${clientStatusType
                .toLowerCase()
                .replace(/_/g, "-")}`,
        });
    }
    setAllowAutoSave(value, clientId = "", statusToBeChanged = null) {
        this.setState({
            statusToBeChanged: statusToBeChanged,
        });
        let isFutureCoveragePeriod = false;
        if (!this.state.confirmedCoverageModal && clientId) {
            /**
             * Will keep getting called as long as the user doesn't confirm the modal.
             */
            isFutureCoveragePeriod = this.isFutureCoveragePeriod(false);
        }
        const body = { newStatus: statusToBeChanged, isSimulation: isFutureCoveragePeriod };
        this.setState({
            allowAutoSave: value,
            statusToBeChanged: statusToBeChanged,
            changeStatusEndpoint: clientId
                ? `/v1/clients/${clientId}/change-status`
                : null,
            changeStatusBody: body,
        });
    }
    hideWarningModal() {
        this.setState({
            ...this.state,
            showModalWarning: false,
            warningClosed: true,
        });
    }

    manageStatusUpdate(clientStatusType, updateClass = true) {
        this.props.changeFieldValue("changeStatusDropDown", "clientStatusType", clientStatusType);
        this.setState({
            currentClientStatus: clientStatusType,
        });
        this.getClientStatusTypeForCurrentStatus(clientStatusType);
        updateClass && this.setClassName(clientStatusType);
    }

    hideErrorModal() {
        const clientStatusType = this.props.client.clientStatusType;
        this.setState({ ...this.state, showModalError: false });
        this.manageStatusUpdate(clientStatusType);
    }

    clientCoverageModalConfirm() {
        this.setState({
            ...this.state,
            confirmedCoverageModal: true,
            showClientCoverageModal: false,
        });
        this.manageStatusUpdate(this.state.statusToBeChanged);
    }

    clientCoverageModalOnClose() {
        this.setState({ ...this.state, showClientCoverageModal: false });
        this.manageStatusUpdate(this.props.client.clientStatusType);
    }

    getWarningModal() {
        return (
            <BSModal
                show={this.state.showModalWarning}
                title={
                    <FormattedMessage id="clients.datatable.actions.showConfirm.title">
                        {(f) => <span className="icon warning">{f}</span>}
                    </FormattedMessage>
                }
                onClose={this.hideWarningModal}
            >
                <FormattedMessage id="clients.autoSaveActiveWarning" />
            </BSModal>
        );
    }

    getClientStatusTypeForCurrentStatus(status) {
        const currentClientStatus = status.toString();
        const statusIndex = validClientStatusTransitions.findIndex((obj) => obj.hasOwnProperty(currentClientStatus));

        if (currentClientStatus === INACTIVE.value) {
            const canActivateClient = userHasAccess([ADMINISTRATOR, FINTECH], true);
            if (!canActivateClient) {
                validClientStatusTransitions[statusIndex][currentClientStatus] =
                    validClientStatusTransitions[statusIndex][currentClientStatus].filter((obj) => {
                        return obj != ACTIVE;
                    });
            }
        }
        this.setState({
            validClientStatusTransitions: validClientStatusTransitions[statusIndex][currentClientStatus],
        });
    }

    customOption({ option }) {
        const { client } = this.props;
        const currentClientStatus = this.state.currentClientStatus;

        return (
            <span
                className={`client-status-type-select status-indicator status-${option.value
                    .toLowerCase()
                    .replace(/_/g, "-")}`}
                onClick={(value) => {
                    const newStatus = value.target.attributes.value.value;
                    if (newStatus == ACTIVE.value && currentClientStatus !== ACTIVE.value) {
                        this.setAllowAutoSave(true, client.clientId, ACTIVE.value);
                    } else if (newStatus === INACTIVE.value && currentClientStatus === ACTIVE.value) {
                        this.props.setShowPlannedInactiveModal(true);
                    } else {
                        this.setAllowAutoSave(false);
                    }
                }}
                value={option.value}
                key={option.value}
            >
                {option.text}
            </span>
        );
    }

    render() {
        const { client, disabled } = this.props;
        const clientStatusTypes = this.state.validClientStatusTransitions;

        const clientId = client.clientId;
        const currentClientStatus = this.state.currentClientStatus;
        return (
            clientStatusTypes && (
                <div className="client-status-type">
                    <Field
                        id="clientStatusType"
                        name="clientStatusType"
                        componentClassName={this.state.className}
                        component={SelectInput}
                        disabled={disabled}
                        props={{
                            onFocus:
                                !this.state.showModalWarning &&
                                    !this.state.warningClosed &&
                                    ![ACTIVE.value, INACTIVE.value].includes(this.props.client.clientStatusType)
                                    ? () =>
                                        this.setState({
                                            ...this.state,
                                            showModalWarning: true,
                                            warningClosed: true,
                                        })
                                    : null,
                            onChange: (value) => {
                                if (value.target.value == ACTIVE.value && currentClientStatus !== ACTIVE.value) {
                                    this.setAllowAutoSave(true, clientId, ACTIVE.value);
                                } else {
                                    this.setAllowAutoSave(false);
                                }
                            },
                        }}
                        options={clientStatusTypes}
                        optionRenderer={this.customOption.bind(this)}
                    />
                    {this.state.changeStatusEndpoint && this.state.allowAutoSave && (
                        <AutoSave
                            setAPIResponse={this.setAPIResponse}
                            statusToBeChanged={this.state.statusToBeChanged}
                            apiEndpoint={this.state.changeStatusEndpoint}
                            body={this.state.changeStatusBody}
                        />
                    )}

                    {this.getWarningModal()}
                    {this.renderActivePassageModal()}
                    {renderErrorModal(
                        this.state.showModalError,
                        this.hideErrorModal,
                        this.state.errorString,
                        this.state.errorMsgKey
                    )}

                    {currentClientStatus === ACTIVE.value && (
                        this.renderPlannedInactiveModal()
                        /**
                         * We don't need to render this if the client is not active.
                         */
                    )}
                    {this.state.formattedMessageCoverageInfo["nextBP"] &&
                        this.state.formattedMessageCoverageInfo["coverageMonth"] ? (
                        <div>
                            {renderConfirmationModal(
                                this.state.showClientCoverageModal,
                                this.clientCoverageModalConfirm,
                                this.clientCoverageModalOnClose,
                                <span>
                                    <FormattedMessage
                                        id="validation.clientFieldValidation.coverageWarning"
                                        values={{
                                            nextBP: this.state.formattedMessageCoverageInfo["nextBP"],
                                            coverageMonth: this.state.formattedMessageCoverageInfo["coverageMonth"],
                                            br: <br />,
                                        }}
                                    />
                                </span>
                            )}
                        </div>
                    ) : null}
                </div>
            )
        );
    }
}

ChangeStatusDropDown.propTypes = {
    changeFieldValue: PropTypes.func,
    dataActions: PropTypes.object,
    invoiceActions: PropTypes.object,
    fields: PropTypes.object,
    onChange: PropTypes.func,
    options: PropTypes.array,
    client: PropTypes.object,
    updateCurrentStatus: PropTypes.func.isRequired,
    inactivationReasonType: PropTypes.string,
    initialValues: PropTypes.object,
    lastActiveDate: PropTypes.string,
    inactivationReasonComplement: PropTypes.string,
    clientId: PropTypes.number,
    setShowPlannedInactiveModal: PropTypes.func,
    showPlannedInactiveModal: PropTypes.bool,
    currentCoveragePeriod: PropTypes.object,
    clientHistory: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    updateTransition: PropTypes.func,
};

ChangeStatusDropDown.contextTypes = {
    intl: intlShape,
};

function mapStateToProps(state) {
    const client = state.data.clients.active;
    return {
        inactivationReasonType: client.inactivationReasonType,
        lastActiveDate: client.lastActiveDate,
        inactivationReasonComplement: client.inactivationReasonComplement,
        clientId: client.clientId,
        currentCoveragePeriod: client.coveragePeriod,
        clientHistory: client.clientHistory || []
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        invoiceActions: bindActionCreators(invoiceActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: formName
    })(ChangeStatusDropDown)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/ChangeStatusDropDown.js